export default __webpack_public_path__ + "static/media/MagdaleneLovelace.f7562715.png";